<template>
  <div class="ListCenter">
    <div class="center">
      <!--轮播//插件-->
      <div id="swiper_ListCenter" class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../../../assets/images/home/ceshi1.jpeg" alt="">
          </div>
          <div class="swiper-slide">
            <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
          </div>
          <div class="swiper-slide">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
          </div>
        </div>
      </div>
      <!--l列表-->
      <div class="ListCenter_conter">
        <div class="card_leftList_centre">
          <div @click="handleToShow" class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <span>小孩蛀牙吃什么药效果好？</span>
              </div>
              <div class="list_twoBox_A">
              <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药
                蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--分页-->
      <Pagination  :pageSize="pageSize" v-model="dataForm.page" @on-jump="jump" />
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import Pagination from '../../../components/pagination/index'
  export default {
    name: "ListCenter",
    components:{
      Pagination
    },
    data(){
      return {
        pageSize:10,
        dataForm:{
          page:1
        }
      }
    },
    methods:{
      // 初始化头部轮播
      _initSwiper() {
        let mySwiper = new Swiper('#swiper_ListCenter', {
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          loop : true,
          observer:true,
          observeParents:true,
          autoplayDisableOnInteraction: false,
        })
      },
      jump(page){

      },
      handleToShow(){
        this.$router.push({path:'/tt/kpArticleShow'+'.html',query:{}})
      }
    },
    mounted() {
      this._initSwiper()
    },
  }
</script>
<style lang="stylus" scoped>
  .ListCenter{
    .center{
      .swiper-container{
        .swiper-wrapper{
          .swiper-slide{
            display flex
            justify-content center
            >img{
              width: 680px
              height: 290px
            }
          }
        }
      }
      .ListCenter_conter{
        margin-top 40px
        .card_leftList_centre{
          padding 0 15px
          .item_List{
            &:after{
              content ''
              display block
              width: 100%
              height: 1px
              border-top 1px solid #eee
              margin 20px 0 25px 0
            }
            .list_twoBox{
              .list_twoBox_Q{
                display flex
                align-items center
                >span {
                  font-weight: 700;
                  font-style: normal;
                  font-size: 16px;
                  color: #333
                  cursor: pointer
                }
              }
              .list_twoBox_A{
                margin-top 10px
                display flex
                align-items center
                >span {
                  font-style: normal;
                  color: #333
                  font-size: 14px;
                  line-height: 22px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
              .list_twoBox_bottom{
                display flex
                align-items center
                .doctor_head{
                  display flex
                  align-items center
                  margin-top 20px
                  >img{
                    width: 60px;
                    height: 60px;
                    border-radius 50%
                    margin-right 15px
                  }
                  .doctor_name{
                    font-weight: 700;
                    font-style: normal;
                    font-size: 14px;
                    color: #5E5E5E;
                    margin-right 30px
                    max-width: 90px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .doctor_hospital{
                    font-size: 14px;
                    color: #5E5E5E;
                    margin-right 30px
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width 150px
                  }
                  .doctor_twoTitle{
                    font-size: 14px;
                    color: #5E5E5E;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width 150px
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/view-tt/kpArticle/ListCenter.vue